<template>
	<div :class="footerClass">
		<FooterMenu />
		<button type="button" class="text-sm underline underline-offset-2 hover:opacity-80" @click="openCookieSettings">{{ $t('Cookie settings') }}</button>
		<!-- <span class="mt-0">{{$t('Copyright by Sitename')}}</span> //-->
		<span class="mt-0">Copyright <a href='https://investments.ro'>Investments.RO</a></span>
	</div>
</template>
<script>
import { mapState } from 'pinia'
// import { checkPopupBodyClass } from '@/utility'
// import LanguageMenuModal from '@/components/modals/LanguageMenuModal.vue'
import FooterMenu from '@/components/menu/FooterMenu.vue';
import { useAuthStore } from '../../store/auth';
import { useAppStore } from '../../store/app'

export default {
	components: { FooterMenu },
	props: {
		fixed: {
			type: Boolean,
			default: false
		}
	},
	data(){
        return{
            // languages: [],
			showFooter : true
        }
    },
	computed: {
		...mapState(useAuthStore, ['user', 'authenticated']),
		...mapState(useAppStore, ['config', 'menus']),
		footerClass(){
			return [
				'main-footer-menu py-2 text-sub-color dark:text-gray-300 dark:border-white/10 text-center min-h-16 self-center w-full flex flex-col items-center justify-center gap-1',
				this.fixed ? 'fixed bottom-0 left-0 right-0 z-10 h-20 md:h-24 lg:h-28' : ''
			].join(' ')
		}
	},
	mounted(){
		if (this.config.emailVerify && this.user.email_verified == 0) {
			this.showFooter = false
		}
	},
	methods: {
		openCookieSettings() {
			window.dispatchEvent(new CustomEvent('open-cookie-preferences'))
		}
	}
}
</script>
